import "./common.css";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import Approutes from "./routes/routes";
import { ToastContainer } from "react-toastify";
import AuthWatcher from "./redux/authWatcher";
import { LoadScript } from "@react-google-maps/api";

function App() {
  return (
    <LoadScript
        googleMapsApiKey={process.env.REACT_APP_MAP_API_KEY || ""}
      >
    <Router>
      <AuthWatcher />
      <Approutes />
      <ToastContainer />
    </Router>
    </LoadScript>
  );
}

export default App;
